import { unpack } from '@/legacy/lib//util';
import Result from '@/legacy/lib//model/Result';

export default class ResultSet
{
  constructor (results)
  {
    this.results = results.map (
      result => new Result (result)
    );
  }

  forEach (cb)
  {
    return this
      .results
      .forEach (cb);
  }

  get (round)
  {
    return this
      .results
      .find (
        result => result.key.round === round
      );
  }

  select (filter)
  {
    for (let result of this.results) {

      A:
      for (let team of result.teams) {
        let p = team.players [0].key;

        for (let k of Object.keys (filter)) {
          if (p [k] !== filter [k]) {
            continue A;
          }
        }

        return result;
      }
    }

    return null;
  }
}